// import RepositoryFactory from "@/apis";
// const Meditation = RepositoryFactory.meditation;
import Meditation from "../../apis/meditation";

export default {
  createMeditation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Meditation.createMeditation(payload);
        // commit("CREATE_MEDITATION", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getMeditation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Meditation.getMeditation(payload);

        commit("GET_MEDITATION", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteMeditation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Meditation.deleteMeditation(payload);
        // commit("DELETE_MEDITATION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editMeditation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Meditation.editMeditation(payload);
        // commit("EDIT_MEDITATION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
